import {TOKENS} from '../../tokens'

export const border = {
  dark: {
    default: TOKENS.dark.contrast_200,
    strong: TOKENS.dark.contrast_500,
    contrast_low: TOKENS.dark.custom_border_contrast_low,
    contrast_high: TOKENS.dark.custom_border_contrast_high,
  },
  light: {
    default: TOKENS.light.contrast_200,
    strong: TOKENS.light.contrast_500,
    contrast_low: TOKENS.light.custom_border_contrast_low,
    contrast_high: TOKENS.light.custom_border_contrast_high,
  },
} as const
